import React from 'react';
import { ContactSectionStyles as S } from './ContactSection.styles';
import { ReactComponent as PhoneCircle } from '@img/icons/phone-circle.svg';
import { ReactComponent as EmailCircle } from '@img/icons/email-circle.svg';
const ContactSection = ({ title, intro, regions }) => {
    return (React.createElement(S.Container, null,
        (title || intro) && (React.createElement(S.TitleSection, null,
            title && React.createElement("h1", null, title),
            intro && React.createElement("div", { dangerouslySetInnerHTML: { __html: intro } }))),
        regions && !!regions.length && regions.map((region, i) => (React.createElement(S.ContactRegion, { key: `ContactSection_Region_${i}` },
            React.createElement("h2", null, region.title),
            React.createElement("ul", null,
                region.phoneNumber && (React.createElement("li", null,
                    React.createElement(PhoneCircle, null),
                    React.createElement("a", { href: `tel:${region.phoneNumber}` }, region.phoneNumber))),
                region.email && (React.createElement("li", null,
                    React.createElement(EmailCircle, null),
                    React.createElement("a", { href: `mailto:${region.email}` }, region.email)))))))));
};
export default ContactSection;
